export const PERSONAL = {
  URL: '/personal',
  TITLE: 'Войти'
}
export const FAVORITES = {
  URL: PERSONAL.URL + '/favorites',
  TITLE: 'Избранное'
}
export const ORDERS = {
  URL: PERSONAL.URL + '/orders',
  TITLE: 'Заказы'
}



// WEBPACK FOOTER //
// ./src/features/Personal/links.js